import { Box, Divider, IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material"
import {
  EditOutlined,
  MoreVertOutlined,
  SubdirectoryArrowRightOutlined,
  VisibilityOutlined,
} from "@mui-symbols-material/w300"
import type { CellContext } from "@tanstack/react-table"
import type { FC } from "react"
import { useRef, useState } from "react"

import { SHOULD_SHOW_UNIMPLEMENTED } from "../../constants"

import type { InventoryByProductItem } from "@/graphql/codegen/graphql"

interface ProductInventoryRowActionsProps {
  row: CellContext<InventoryByProductItem, unknown>["row"]
  canMaintain: boolean
  onAdjust?: (inventory: InventoryByProductItem) => void
  onTransfer?: (inventory: InventoryByProductItem) => void
  onProductView?: (inventory: InventoryByProductItem) => void
  onCoaView?: (inventory: InventoryByProductItem) => void
}

export const ProductInventoryRowActions: FC<ProductInventoryRowActionsProps> = ({
  row,
  canMaintain,
  onAdjust,
  onTransfer,
  onProductView,
  onCoaView,
}) => {
  const anchorElRef = useRef<HTMLButtonElement>(null)
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const handleClick = (e: React.MouseEvent) => e.stopPropagation()

  const handleMenuOpen = () => setIsMenuOpen(true)

  const handleMenuClose = () => setIsMenuOpen(false)

  const handleAdjust = () => {
    handleMenuClose()
    onAdjust?.(row.original)
  }

  const handleTransfer = () => {
    handleMenuClose()
    onTransfer?.(row.original)
  }

  const handleProductView = () => {
    handleMenuClose()
    onProductView?.(row.original)
  }

  const handleCoaView = () => {
    handleMenuClose()
    onCoaView?.(row.original)
  }

  return (
    <Box className='flex items-center justify-end' ref={anchorElRef} onClick={handleClick}>
      <IconButton
        className='mt-[-8px]'
        onClick={handleMenuOpen}
        data-testid='product-inventory.row-actions.actions-button'
      >
        <MoreVertOutlined />
      </IconButton>
      <Menu
        anchorEl={anchorElRef.current}
        open={isMenuOpen}
        onClose={handleMenuClose}
        data-testid='product-inventory.row-actions.actions-menu'
      >
        {SHOULD_SHOW_UNIMPLEMENTED && canMaintain && (
          <>
            <MenuItem onClick={handleAdjust} data-testid='product-inventory.row-actions.adjust-inventory-item'>
              <ListItemIcon>
                <EditOutlined />
              </ListItemIcon>
              <ListItemText primary='Adjust Inventory' />
            </MenuItem>
            <MenuItem onClick={handleTransfer} data-testid='product-inventory.row-actions.transfer-inventory-item'>
              <ListItemIcon>
                <SubdirectoryArrowRightOutlined />
              </ListItemIcon>
              <ListItemText primary='Transfer Inventory' />
            </MenuItem>
            <Divider />
          </>
        )}
        <MenuItem onClick={handleProductView} data-testid='product-inventory.row-actions.view-product-item'>
          <ListItemIcon>
            <VisibilityOutlined />
          </ListItemIcon>
          <ListItemText primary='View Product Detail' />
        </MenuItem>
        <MenuItem onClick={handleCoaView} data-testid='product-inventory.row-actions.view-coa-item'>
          <ListItemIcon>
            <VisibilityOutlined />
          </ListItemIcon>
          <ListItemText primary='View COA' />
        </MenuItem>
      </Menu>
    </Box>
  )
}
